import { render, staticRenderFns } from "./vpn-status-bar.vue?vue&type=template&id=4706dbae"
import script from "./vpn-status-bar.vue?vue&type=script&lang=js"
export * from "./vpn-status-bar.vue?vue&type=script&lang=js"
import style0 from "./vpn-status-bar.vue?vue&type=style&index=0&id=4706dbae&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports